import React, { useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaTicketAlt,
  FaGlobe,
  FaSignInAlt,
  FaUserPlus,
  FaSignOutAlt,
  FaUsers,
  FaBars,
  FaCog,
  FaUserCircle,
  FaChevronDown,
  FaTimes,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import "./Navbar.css";
import { useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCurrentLanguage } from "../apps/tickets/store/translationSlice.js";
import { API_END_POINTS } from "../network/apiEndPoint";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import lift14Img from "../assets/lift14_2.svg";
import { baseURL } from "../network/baseUrl.js";

const Navbar = () => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const fullName = localStorage.getItem("name") || "User";
  const firstName = fullName.split(" ")[0];
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [newTicket, setNewTicket] = useState({
    title: "",
    description: "",
    priority: "",
    category: "",
    customer_company: "",
    customer_name: "",
    customer_phone: "",
    customer_email: "",
    internal_notes: "",
  });
  const languageDropdownRef = useRef(null);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const userName = localStorage.getItem("name") || "User";
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  });
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const userDropdownRef = useRef(null);
  const [showLogoutLoader, setShowLogoutLoader] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const isLoggedIn = localStorage.getItem("access") !== null;

  const isAuthPage = ["/login"].includes(location.pathname);

  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    const role = localStorage.getItem("userRole");
    setUserRole(role);
  }, []);
  const handleToggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };
  const handleToggleUserDropdown = () => {
    setShowUserDropdown((prev) => !prev);
  };

  // Updated click outside handlers to prevent conflicts
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Handle language dropdown
      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target)
      ) {
        setIsLanguageDropdownOpen(false);
      }

      // Handle user dropdown
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(event.target)
      ) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Updated mobile menu click outside handler to exclude language dropdown
  useEffect(() => {
    const handleClickOutsideMenu = (event) => {
      if (
        isMobileMenuOpen &&
        !event.target.closest(".mobilenav") &&
        !event.target.closest(".language-dropdown-mobile")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideMenu);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideMenu);
    };
  }, [isMobileMenuOpen]);

  // Simplified navbar title based on role
  const navbarTitle = (() => {
    switch (userRole) {
      case "admin":
        // return t('dashboard.adminTitle');
        return t("createAsset.buttons.M-Desk");
      case "asset_manager":
        // return t('dashboard.ticket_managerTitle');
        return t("createAsset.buttons.M-Desk");
      case "customer_manager":
        // return t('dashboard.customer_managerTitle');
        return t("createAsset.buttons.M-Desk");
      case "warehouse_manager":
        // return t('dashboard.sales_managerTitle');
        return t("createAsset.buttons.M-Desk");
      case "finance_manager":
        // return t('dashboard.userTitle');
        return t("createAsset.buttons.M-Desk");
      case "user":
        return t("createAsset.buttons.M-Desk");
      default:
        // return t('dashboard.title');
        return t("createAsset.buttons.M-Desk");
    }
  })();
  const menuItems = (() => {
    switch (userRole) {
      case "asset_manager":
        return [
          {
            // path: '/dashboard/asset-manager',
            label: "Asset System",
            // icon: <FaClipboardList />
            path: "/dashboard",
          },

          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.HelpCenter"),
          // },
          //  {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.HelpCenter"),
          // },
          {
            //  path: '/admin/dashboard',
            path: "/contact",
            label: t("createAsset.buttons.contactus"),
          },
          // {
          //   //  path: '/admin/dashboard',
          //     label: t('createAsset.buttons.Knowledge'),
          //   },
          // {
          //   //  path: '/admin/dashboard',
          //     label: t('createAsset.buttons.Marketing'),
          //   },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Trucks"),
          // },
        ];
      case "user":
        return [
          {
            // path: '/dashboard/asset-manager',
            label: t("createAsset.buttons.AssetSystem"),
            // icon: <FaClipboardList />
          },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.HelpCenter"),
          // },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Knowledge"),
          // },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Marketing"),
          // },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Trucks"),
          // },
          {
            path: "/contact",
            label: t("createAsset.buttons.contactus"),
          },
        ];
        case "undefined":
      case "customer_manager":
        return [
          {
            // path: '/dashboard/asset-manager',
            label: t("createAsset.buttons.AssetSystem"),
            // icon: <FaClipboardList />
          },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.HelpCenter"),
          // },
          // {
          //   //  path: '/admin/dashboard',
          //     label: t('createAsset.buttons.Knowledge'),
          //   },
          //   {
          //     //  path: '/admin/dashboard',
          //       label: t('createAsset.buttons.Marketing'),
          //     },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Trucks"),
          // },
          {
            path: "/contact",
            label: t("createAsset.buttons.contactus"),
          },
        ];
      case "warehouse_manager":
        return [
          {
            // path: '/dashboard/asset-manager',
            label: t("createAsset.buttons.AssetSystem"),
            // icon: <FaClipboardList />
          },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.HelpCenter"),
          // },

          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Trucks"),
          // },
          {
            path: "/contact",
            label: t("createAsset.buttons.contactus"),
          },
        ];
      case "admin":
        return [
          {
            path: "/dashboard",
            label: "Asset System",
            // icon: <FaClipboardList />
          },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("sidebar.admin.helpcenter"),
          // },

          // {
          //   //  path: '/admin/dashboard',
          //   label: t("sidebar.admin.Trucks"),
          // },

          {
            path: "/contact",
            label: t("createAsset.buttons.contactus"),
          },
        ];
      case "finance_manager":
        return [
          {
            // path: '/dashboard/user',
            label: t("createAsset.buttons.AssetSystem"),
            // icon: <FaClipboardList />
          },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.HelpCenter"),
          // },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Knowledge"),
          // },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Marketing"),
          // },
          // {
          //   //  path: '/admin/dashboard',
          //   label: t("createAsset.buttons.Trucks"),
          // },
          {
            path: "/contact",
            label: t("createAsset.buttons.contactus"),
          },
        ];
      default:
        return [];
    }
  })();

  const handleTicketSystemClick = () => {
    if (!isLoggedIn) {
      toast.warn(t("toast.loginMessage"));
      return;
    }

    let targetRoute = "/dashboard"; // Default route
    switch (userRole) {
      case "admin":
        targetRoute = "/dashboard";
        break;
      case "customer_manager":
        targetRoute = "/dashboard";
        break;
      case "asset_manager":
        targetRoute = "/dashboard";
        break;
      case "warehouse_manager":
        targetRoute = "/dashboard";
        break;
      case "finance_manager":
        targetRoute = "/dashboard";
        break;
      default:
        break;
    }
    navigate(targetRoute);
  };

  const getCreateButtonText = () => {
    switch (userRole) {
      case "admin":
        return "Create Manager";
      case "ticket_manager":
        return "Create Ticket";
      case "customer_manager":
        return "Add Customer";
      case "sales_manager":
        return "Create Sales Ticket";
      case "user":
        return "Create Ticket";
      default:
        return "Create";
    }
  };

  // Updated changeLanguage function with better mobile handling
  const changeLanguage = async (lang) => {
    console.log("change language function triggered .... ", lang);
    try {
      const prevLang = i18n.language;

      if (prevLang !== lang) {
        await i18n.changeLanguage(lang);
        localStorage.setItem("selectedLanguage", lang);
        dispatch(setCurrentLanguage(lang));

        // Close the language dropdown
        setIsLanguageDropdownOpen(false);

        console.log("Language changed successfully to:", lang);
      }
    } catch (error) {
      console.error("Language change failed:", error);
      alert("Failed to change language");
    }
  };

  const handleLogout = async () => {
    // Get all dashboard components
    const dashboards = document.querySelectorAll(".dashboard-container");
    dashboards.forEach((dashboard) => {
      const component = dashboard.__reactFiber$;
      if (component && component.setShowLogoutLoader) {
        component.setShowLogoutLoader(true);
      }
    });

    setIsLoggingOut(true);
    setShowLogoutLoader(true);

    try {
      const refreshToken = localStorage.getItem("refresh");
      const accessToken = localStorage.getItem("access");

      if (!refreshToken || !accessToken) {
        console.error("Token not found");
        alert("You are already logged out");
        navigate("/");
        return;
      }

      const response = await fetch(API_END_POINTS.logout, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          refresh: refreshToken,
        }),
      });

      if (response.ok) {
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        localStorage.removeItem("userRole");
        localStorage.removeItem("name");
        localStorage.removeItem("userEmail");
        navigate("/");
      } else {
        const errorData = await response.json();
        console.error("Logout failed:", errorData);
        alert(
          `Logout failed: ${errorData.error || "Unexpected error occurred"}`
        );
      }
    } catch (error) {
      console.error("Error logging out:", error);
      alert("An error occurred while logging out. Please try again.");
    } finally {
      setIsLoggingOut(false);
      setShowLogoutLoader(false);
      // Reset loader state in all dashboard components
      const dashboards = document.querySelectorAll(".dashboard-container");
      dashboards.forEach((dashboard) => {
        const component = dashboard.__reactFiber$;
        if (component && component.setShowLogoutLoader) {
          component.setShowLogoutLoader(false);
        }
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTicket((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitTicket = (e) => {
    e.preventDefault();
    // Add your API call here to submit the ticket
    console.log("New Ticket:", newTicket);
    setShowTicketModal(false);
    // Reset form
    setNewTicket({
      title: "",
      description: "",
      priority: "",
      category: "",
      customer_company: "",
      customer_name: "",
      customer_phone: "",
      customer_email: "",
      internal_notes: "",
    });
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitPasswordChange = async (e) => {
    e.preventDefault();

    // First check if new passwords match
    if (passwordData.newPassword !== passwordData.newPasswordConfirm) {
      toast.error(t("dashboardToasters.newAndOldPasswordNotMatch"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return;
    }

    // Check if new password is same as current password
    if (passwordData.oldPassword === passwordData.newPassword) {
      toast.error(t("dashboardToasters.newAndOldPassCannotBeSame"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return;
    }
    const passwordValidation = validatePassword(passwordData.newPassword);
    if (!passwordValidation.isValid) {
      toast.error(passwordValidation.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
      });
      return;
    }

    setIsChangingPassword(true);
    const token = localStorage.getItem("access");

    try {
      const response = await axios.post(
        `${baseURL}/update-password/`,
        {
          old_password: passwordData.oldPassword,
          new_password: passwordData.newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        if (!toast.isActive("password-success")) {
          toast.success(t("dashboardToasters.passChangeSuccess"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            toastId: "password-success",
          });
        }
        setShowChangePasswordModal(false);
        setPasswordData({
          oldPassword: "",
          newPassword: "",
          newPasswordConfirm: "",
        });
      }
    } catch (error) {
      if (error.response) {
        // Check for incorrect current password error
        if (
          error.response.status === 400 &&
          error.response.data?.message
            ?.toLowerCase()
            .includes("current password")
        ) {
          toast.error(t("dashboardToasters.incorrectCurrPass"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        } else if (error.response.status === 401) {
          toast.error(t("dashboardToasters.sessionExpiration"), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
          navigate("/login");
        } else {
          // For any other error
          const errorMessage = t("dashboardToasters.incorrectCurrPass");
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      } else {
        toast.error(t("dashboardToasters.genricError"), {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }
      console.error("Error changing password:", error);
    } finally {
      setIsChangingPassword(false);
    }
  };
  const validatePassword = (password) => {
    const passwordCriteria =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordCriteria.test(password)) {
      return {
        isValid: false,
        message: t("loginToasters.passwordValidationMessage"),
      };
    }
    return { isValid: true };
  };

  // Update userProfile to use the name from localStorage
  const userProfile = {
    name: fullName,
    email: localStorage.getItem("userEmail"),
    role: (() => {
      const role = localStorage.getItem("userRole");
      switch (role) {
        case "admin":
          return "Administrator";
        case "asset_manager":
          return "Asset Manager";
        case "customer_manager":
          return "Customer Manager";
        case "warehouse_manager":
          return "Warehouse Manager";
        case "finance_manager":
          return "Finance Manager";
        default:
          return "User";
      }
    })(),
  };

  // Add these language options
  const languages = [
    { code: "en", name: "English", flag: "🇬🇧" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
  ];

  // Add useEffect to handle the custom event for ticket refresh
  useEffect(() => {
    const handleRefreshTickets = (event) => {
      // This event will be caught by your tickets component to refresh the list
      console.log("Refreshing tickets for language:", event.detail.language);
    };

    window.addEventListener("refreshTickets", handleRefreshTickets);

    return () => {
      window.removeEventListener("refreshTickets", handleRefreshTickets);
    };
  }, []);

  // Post-login dashboard navbar
  if (showLogoutLoader) {
    return (
      <div className="loader-overlay">
        <div className="loader-content">
          <div className="modern-loader"></div>
          <div className="loader-text">Logging out...</div>
        </div>
      </div>
    );
  }

  const handleToggleLanguageDropdown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };

  const handleMobileLanguageClick = async (langCode, e) => {
    e.preventDefault();
    e.stopPropagation();

    console.log("Mobile language button clicked:", langCode);

    await changeLanguage(langCode);
  };

  return (
    <>
      <header className="bg-[#1b1b1b] shadow-sm sticky top-0 z-50 border-white">
        <div className="mx-auto  sm:px-6 lg:px-8">
          <div className="flex px-3 justify-between items-center h-16">
            {/* Logo and Title */}
            <Link
              to="/"
              className="flex items-center text-gray-300 hover:text-white transition-colors duration-200"
            >
              <span className="font-bold text-lg sm:text-xl">
                <img
                  className="h-[25%] w-[25%] object-center"
                  src={lift14Img}
                  alt="logo"
                />
              </span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-6">
              {/* Menu Items */}
              <div className="flex items-center space-x-4">
                {menuItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    onClick={() => {
                      if (item?.path) {
                        navigate(item?.path);
                        handleTicketSystemClick();
                      }
                    }}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${location.pathname === item.path
                        ? "bg-gray-700 text-white"
                        : "text-gray-300 hover:bg-gray-700 hover:text-white"
                      }`}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>

              <div className="w-[400px]   mx-0 px-1 sm:px-2 md:px-4  bg-[#1b1b1b]">
                {/* Search component can be added here if needed */}
              </div>

              {/* Language Dropdown */}
              <div
                className="relative z-[100] language-dropdown-container"
                ref={languageDropdownRef}
              >
                <button
                  className="text-gray-300 hover:text-white p-2 rounded-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
                  }}
                >
                  <FaGlobe className="h-5 w-5" />
                </button>

                {isLanguageDropdownOpen && (
                  <div
                    className="absolute right-0 mt-2 w-48 bg-gray-800 shadow-lg py-1 z-[60] rounded-md"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {languages.map((lang) => (
                      <button
                        key={lang.code}
                        className={`w-full text-left px-4 py-2 text-sm z-[60] transition-colors ${i18n.language === lang.code
                            ? "bg-gray-700 text-white"
                            : "text-gray-300 hover:bg-gray-700"
                          }`}
                        onClick={async (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          console.log(
                            "Desktop language button clicked:",
                            lang.code
                          );
                          await changeLanguage(lang.code);
                        }}
                      >
                        <span className="mr-2 z-[60]">{lang.flag}</span>
                        <span>{lang.name}</span>
                        {i18n.language === lang.code && (
                          <span className="ml-2">✓</span>
                        )}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* User Dropdown */}
              <div className="relative" ref={userDropdownRef}>
                <button
                  className="flex items-center space-x-2 text-gray-300 hover:text-white hover:bg-gray-700 px-3 py-2 rounded-md transition-colors duration-200"
                  onClick={handleToggleUserDropdown}
                >
                  <FaUserCircle className="w-5 h-5" />
                  <span className="hidden xl:inline text-sm font-medium">
                    {firstName}
                  </span>
                  <FaChevronDown className="w-4 h-4" />
                </button>

                {showUserDropdown && (
                  <div className="absolute right-0 mt-2 w-72 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                    {/* Profile Header */}
                    <div className="px-4 py-3 border-b border-gray-200">
                      <div className="flex items-center">
                        <FaUserCircle className="w-10 h-10 text-gray-400" />
                        <div className="ml-3">
                          <div className="text-sm font-medium text-gray-900">
                            {userProfile.name}
                          </div>
                          <div className="text-sm text-gray-500">
                            {userProfile.role}
                          </div>
                          {userProfile.email && (
                            <div className="text-xs text-gray-400">
                              {userProfile.email}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Menu Items */}
                    <div className="py-1">
                      {userRole === "admin" && (
                        <Link
                          to="/admin/users"
                          className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          <FaUsers className="w-4 h-4 mr-3" />
                          {t("navbar-profile.users")}
                        </Link>
                      )}
                      <button
                        onClick={() => setShowChangePasswordModal(true)}
                        className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      >
                        <FaCog className="w-4 h-4 mr-3" />
                        {t("navbar.changePassword")}
                      </button>
                      <div className="border-t border-gray-200"></div>
                      <button
                        onClick={handleLogout}
                        className="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                        disabled={isLoggingOut}
                      >
                        {isLoggingOut ? (
                          <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-red-600 mr-3"></div>
                            <span>{t("navbar.logout")}</span>
                          </>
                        ) : (
                          <>
                            <FaSignOutAlt className="w-4 h-4 mr-3" />
                            {t("navbar.logout")}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </nav>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2 text-gray-300 hover:text-white hover:bg-gray-700 rounded-md transition-colors duration-200"
              onClick={handleToggleMobileMenu}
            >
              {isMobileMenuOpen ? (
                <FaTimes className="w-6 h-6" />
              ) : (
                <FaBars className="w-6 h-6" />
              )}
            </button>
          </div>

          {/* Mobile Navigation Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden ">
              <nav className="w-full bg-gray-800 px-4 pt-2 pb-4 shadow-md mobilenav">
                {/* Mobile Menu Items */}
                {menuItems.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      if (item.onClick) item.onClick();
                      setIsMobileMenuOpen(false);
                      handleTicketSystemClick();
                    }}
                    className="py-2 cursor-pointer"
                  >
                    <span
                      className={`block text-gray-300 hover:text-white transition-colors ${location.pathname === item.path
                          ? "text-white font-medium"
                          : ""
                        }`}
                    >
                      {item.label}
                    </span>
                  </div>
                ))}

                {/* Mobile Language Dropdown - FIXED */}
                <div
                  className="py-2 language-dropdown-mobile"
                  ref={languageDropdownRef}
                >
                  <button
                    className="flex items-center text-gray-300 hover:text-white transition-colors"
                    onClick={handleToggleLanguageDropdown}
                  >
                    <FaGlobe className="w-5 h-5 mr-2" />
                    <span>Language</span>
                  </button>

                  {isLanguageDropdownOpen && (
                    <div
                      className="mt-2 bg-gray-700 w-full  "
                      onClick={(e) => e.stopPropagation()}
                    >
                      {languages.map((lang) => (
                        <button
                          key={lang.code}
                          className={`w-full text-left px-4 py-2 flex items-center justify-between text-sm text-gray-300 hover:bg-gray-600 transition-colors ${i18n.language === lang.code ? "bg-gray-600" : ""
                            }`}
                          onClick={(e) =>
                            handleMobileLanguageClick(lang.code, e)
                          }
                        >
                          <div className="flex items-center">
                            <span className="mr-2 ">{lang.flag}</span>
                            <span className="">{lang.name}</span>
                          </div>
                          {i18n.language === lang.code && (
                            <span className="text-green-500">✓</span>
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Mobile User Menu */}
                <div className="py-2" ref={userDropdownRef}>
                  <button
                    className="flex items-center w-full text-gray-300 hover:text-white transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowUserDropdown(!showUserDropdown);
                    }}
                  >
                    <FaUserCircle className="w-5 h-5 mr-2" />
                    <span>{firstName}</span>
                    <FaChevronDown className="w-3 h-3 ml-1" />
                  </button>

                  {showUserDropdown && (
                    <div className="mt-2 bg-gray-700 w-full  shadow-lg overflow-hidden">
                      <div className="p-3 border-b border-gray-600">
                        <div className="flex items-start space-x-3">
                          <FaUserCircle className="w-8 h-8 text-gray-400" />
                          <div>
                            <span className="font-medium text-white">
                              {userProfile.name}
                            </span>
                            <div className="text-sm text-gray-400">
                              {userProfile.role}
                            </div>
                            {userProfile.email && (
                              <div className="text-xs text-gray-400">
                                {userProfile.email}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {userRole === "admin" && (
                        <Link
                          to="/admin/users"
                          className="block px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          <div className="flex items-center">
                            <FaUsers className="h-5 w-5 mr-3 text-gray-400" />
                            {t("navbar-profile.users")}
                          </div>
                        </Link>
                      )}

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowChangePasswordModal(true);
                          setIsMobileMenuOpen(false);
                        }}
                        className="w-full block px-3 py-2 text-base font-medium text-gray-300 hover:bg-gray-700 hover:text-white text-left transition-colors"
                      >
                        <div className="flex items-center">
                          <FaCog className="h-5 w-5 mr-3 text-gray-400" />
                          {t("navbar.changePassword")}
                        </div>
                      </button>

                      <button
                        className="w-full flex items-center space-x-3 px-4 py-2 text-left text-gray-300 hover:bg-gray-600 transition-colors"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleLogout();
                        }}
                        disabled={isLoggingOut}
                      >
                        {isLoggingOut ? (
                          <>
                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-300 mr-3"></div>
                            <span>{t("navbar.logout")}</span>
                          </>
                        ) : (
                          <>
                            <FaSignOutAlt className="w-4 h-4" />
                            <span>{t("navbar.logout")}</span>
                          </>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        className="z-50"
      />

      {/* New Ticket Modal */}
      {showTicketModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h5 className="text-lg font-semibold text-gray-900">
                {t("ticketForm.title")}
              </h5>
              <button
                type="button"
                className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                onClick={() => setShowTicketModal(false)}
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            <form onSubmit={handleSubmitTicket} className="p-6">
              {/* Basic Ticket Info */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t("ticketForm.fields.title")}{" "}
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="title"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter ticket title"
                    value={newTicket.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="description"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter detailed description"
                    rows="3"
                    value={newTicket.description}
                    onChange={handleInputChange}
                    required
                  ></textarea>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Priority <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="priority"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={newTicket.priority}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Priority</option>
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Category <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="category"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={newTicket.category}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select Category</option>
                      <option value="Hardware Issue">Hardware Issue</option>
                      <option value="Software Issue">Software Issue</option>
                      <option value="Network Issue">Network Issue</option>
                      <option value="Access Issue">Access Issue</option>
                    </select>
                  </div>
                </div>

                {/* Customer Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Company Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="customer_company"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter company name"
                      value={newTicket.customer_company}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Contact Person <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="customer_name"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter contact name"
                      value={newTicket.customer_name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="customer_phone"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter phone number"
                      value={newTicket.customer_phone}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="customer_email"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter email address"
                      value={newTicket.customer_email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Internal Notes
                  </label>
                  <textarea
                    name="internal_notes"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Add any internal notes or comments"
                    rows="2"
                    value={newTicket.internal_notes}
                    onChange={handleInputChange}
                  ></textarea>
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-6 pt-6 border-t border-gray-200">
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  onClick={() => setShowTicketModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  {t("ticketForm.buttons.create")}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Change Password Modal */}
      {showChangePasswordModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">
                {t("passwordModal.title")}
              </h2>
              <button
                className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                onClick={() => setShowChangePasswordModal(false)}
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            <form onSubmit={handleSubmitPasswordChange} className="p-6">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t("passwordModal.currentPassword")}
                  </label>
                  <div className="relative">
                    <input
                      type={showOldPassword ? "text" : "password"}
                      name="oldPassword"
                      value={passwordData.oldPassword}
                      onChange={handlePasswordChange}
                      required
                      placeholder={t(
                        "passwordModal.currentPasswordPlaceholder"
                      )}
                      minLength="8"
                      className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                      onClick={() => setShowOldPassword(!showOldPassword)}
                    >
                      {showOldPassword ? (
                        <FaEyeSlash className="w-4 h-4" />
                      ) : (
                        <FaEye className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t("passwordModal.newPassword")}
                  </label>
                  <div className="relative">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      name="newPassword"
                      value={passwordData.newPassword}
                      onChange={handlePasswordChange}
                      required
                      placeholder={t("passwordModal.newPasswordPlaceholder")}
                      minLength="8"
                      className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      {showNewPassword ? (
                        <FaEyeSlash className="w-4 h-4" />
                      ) : (
                        <FaEye className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t("passwordModal.confirmPassword")}
                  </label>
                  <div className="relative">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="newPasswordConfirm"
                      value={passwordData.newPasswordConfirm}
                      onChange={handlePasswordChange}
                      required
                      placeholder={t(
                        "passwordModal.confirmPasswordPlaceholder"
                      )}
                      minLength="8"
                      className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                    <button
                      type="button"
                      className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? (
                        <FaEyeSlash className="w-4 h-4" />
                      ) : (
                        <FaEye className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-3 mt-6">
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  onClick={() => setShowChangePasswordModal(false)}
                  disabled={isChangingPassword}
                >
                  {t("createAsset.buttons.cancel")}
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={isChangingPassword}
                >
                  {isChangingPassword ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2 inline-block"></div>
                      {t("passwordModal.buttons.change")}
                    </>
                  ) : (
                    t("passwordModal.buttons.change")
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
